<script>
    export default {
        name: 'Toast',
        props: {
            id: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            text: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: ''
            },
            options: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                open: false
            }
        },

        watch: {
            // close from snackbar timeout
            open(val) {
                if (!val) this.close()
            }
        },

        beforeMount() {
            const $app = document.querySelector('#app') || document.body || document.getElementsByTagName('body')[0]
            if ($app) $app.appendChild(this.$el)
        },
        mounted() {
            this.open = true
            this.$nextTick(() => {
                const $el = document.querySelector(`#${this.id}`)
                if ($el) $el.close = this.close.bind(this)
                this.$options.onMounted($el)
            })
        },
        methods: {
            close() {
                if (this.open) this.open = false
                setTimeout(() => {
                    this.$options.onClose()
                    this.$destroy()
                    removeElement(this.$el)
                }, 400) // wait for close animation
            },
            onAction() {
                this.$options.onAction()
            }
        }
    }

    function removeElement(el) {
        typeof el.remove !== 'undefined' ? el.remove() : el.parentNode.removeChild(el)
    }
</script>

<template>
    <VSnackbar :id="id" v-model="open" v-bind="options" class="v-toast v-toast--hidden">
        <div class="v-toast__content">
            <div v-if="title" class="title mb-2">{{ title }}</div>
            <div class="subtitle-1">{{ text }}</div>
        </div>
        <template slot="action">
            <VBtn v-if="options.closeable" icon dark @click.native="close">
                <VIcon>mdi-close</VIcon>
            </VBtn>
            <VBtn v-if="options.action" text @click.native="onAction">{{ options.action }}</VBtn>
        </template>
    </VSnackbar>
</template>

<style scoped>
    .v-toast {
        z-index: 1000 !important;
    }
    .v-toast.v-toast--hidden {
        display: none;
    }
    .v-toast__content {
        max-height: 600px;
        overflow: hidden;
        word-break: break-all;
    }
</style>
